// extracted by mini-css-extract-plugin
export var completionBody = "_fk-2";
export var completionCard = "_fk-0";
export var completionFooter = "_fk-3";
export var completionTitle = "_fk-1";